import { Loader } from "@googlemaps/js-api-loader";

const API_KEY = "AIzaSyC3z_oWS6UbpDDGb1mPoQuxyu2C8hUh_bc";

export function initializeMap(element, markers = {}, mapOptions = {}) {
    const loader = new Loader({
        apiKey: API_KEY,
        version: "weekly",
        libraries: ["places"], // Add any additional libraries you need
    });

    loader.load().then(() => {
        if (mapOptions.latitude && mapOptions.longitude) {
            mapOptions["center"] = new google.maps.LatLng(
                mapOptions.latitude,
                mapOptions.longitude
            );
        }

        // Initialize and render the map
        const map = new google.maps.Map(document.querySelector(element), {
            ...{
                center: new google.maps.LatLng(48.65, 19.65),
                zoom: 7,
                clickableIcons: false,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                gestureHandling: "cooperative",
            },
            ...mapOptions,
        });

        // Add markers
        if (Object.keys(markers).length !== 0) {
            for (const branch of Object.values(markers)) {
                const markerPosition = { lat: branch.latitude, lng: branch.longitude };
                const markerOptions = {
                    position: markerPosition,
                    map: map,
                    title: branch.name,
                };

                if (branch.icon) {
                    markerOptions["icon"] = branch.icon;
                }

                const marker = new google.maps.Marker(markerOptions);
            }
        }
    });
}
